export default defineNuxtPlugin({
    name: 'supabase-auth',
    async setup(nuxtApp) {
        nuxtApp.hooks.hook('app:mounted', () => {
            const supabase = useSupabase()

            supabase.auth.onAuthStateChange((event, session) => {
                if (event === 'INITIAL_SESSION') return

                useUser().value = session?.user || null
                useProfile().value = null

                // this will re-run the middlewares for the current route
                navigateTo({ force: true, replace: true })
            })
        })
    },
})